export default () => ({
	apiUrl: "https://api.breezeline.com",
	environment: "",
	buyflowMaintenance: 0,
	buyflowMaintenanceTimeframe: "",
	googleApiKey: "AIzaSyAC-Um_QGQezudasD8Ni5k0UZXAsI-Ys4o",
	googleAnalytics: "UA-7645120-8",
	personalizationEventLoggerUrl: 'https://api-staging.breezeline.com/api/v1/is/ping',
	googleRecaptchaV2SiteKey: '6LeW8pgUAAAAAPx_0jOMIP9xZkQETUXg2qqvVM2_',
	googleRecaptchaV3SiteKey: '6Lfa8JgUAAAAAGv8OOkUc9imdceT90--3CORyD-w',
})